import { Button, Form, Input, Modal, Select } from "antd";

import { selectFormOptionsNoFormatting } from "../../../../../utils/helper";

const CreateEditResourceModal = ({
  isModalOpen = false,
  isEdit = false,
  setIsModalOpen = () => {},
  initialValues = {},
  handleCreateEdit = () => {}
}) => {
  const [form] = Form.useForm();
  return (
    <Modal
      title="Create New Resource"
      centered
      open={isModalOpen}
      footer={[]}
      onOk={() => {
        setIsModalOpen(false);
      }}
      onCancel={() => setIsModalOpen(false)}
    >
      <Form
        form={form}
        initialValues={isEdit ? initialValues : {}}
        name="new_subsection_form"
        onFinish={handleCreateEdit}
      >
        <Form.Item
          name="title"
          label="Title"
          rules={[
            {
              required: true,
              message: "Please enter a title!"
            }
          ]}
        >
          <Input />
        </Form.Item>
        <Form.Item
          name="category"
          label="Category"
          rules={[
            {
              required: true,
              message: "Please select a category!"
            }
          ]}
        >
          <Select
            options={selectFormOptionsNoFormatting(["FEEDBACK_FORM", "DATA_LINK"])}
            showSearch
            allowClear
          />
        </Form.Item>
        <Form.Item
          name="link"
          label="Resource Link"
          rules={[
            {
              required: true,
              message: "Please paste a link!"
            },
            {
              pattern: /^(https:\/\/)?([\da-z.-]+)\.([a-z.]{2,6})([/\w.-]*)*\/?$/,
              message: "Please paste a valid  link!"
            }
          ]}
        >
          <Input />
        </Form.Item>
        <Form.Item className="submit-btn">
          <Button type="primary" htmlType="submit">
            {isEdit === true ? "Update" : "Create"} Resource
          </Button>
        </Form.Item>
      </Form>
    </Modal>
  );
};

export default CreateEditResourceModal;
